import type { Sides } from '@kerfjs/ui/toolbar';
import { Toolbar } from '@kerfjs/ui/toolbar';
import { type HeadingLevel, ToolbarText, type ToolbarTextSize } from '@kerfjs/ui/toolbar-text';
import type { SafeHtml } from 'kerfjs';

/** A wrapping toolbar title for framed content, with optional trailing groups. */
export function CardHeader({
  title,
  headingLevel = 2,
  size = 'large',
  dividerSides = '',
  id,
  trailing,
}: {
  title: string;
  headingLevel?: HeadingLevel;
  size?: ToolbarTextSize;
  dividerSides?: Sides;
  id?: string;
  trailing?: SafeHtml;
}): SafeHtml {
  return (
    <Toolbar
      responsive="wrap"
      dividerSides={dividerSides}
      leading={<ToolbarText size={size} headingLevel={headingLevel} text={title} id={id} wrap />}
      trailing={trailing}
    />
  );
}
